import {
    AccountingTransactionType,
    CicTypeEnum,
    CurrencyEnum,
    InstrumentModelTypeEnum,
    TAccountGroup1Enum,
    TAccountGroup2Enum,
    TAccountGroup3Enum,
    TAccountGroup4Enum,
    TAccountGroup5Enum,
    UpsertTAccountInput,
    TAccountMappingValue,
    TAccountTypeEnum,
    UpsertTAccountMappingInput
} from "../types";

export const DEFAULT_TACCOUNT_MAPPING_VALUES: TAccountMappingValue[] = [
    { accountingTransactionType: AccountingTransactionType.InitialCost, credit: "13INITC", debit: "13INITD" },
    { accountingTransactionType: AccountingTransactionType.ValueChange, credit: "14VALC", debit: "14VALD" },
    { accountingTransactionType: AccountingTransactionType.ForwardCash, credit: "15FCAC", debit: "24FCAD" },
    { accountingTransactionType: AccountingTransactionType.AccruedInterest, credit: "17ACCC", debit: "29ACCD" },
    { accountingTransactionType: AccountingTransactionType.Dividend, credit: "82DIVC", debit: "82DIVD" },
    { accountingTransactionType: AccountingTransactionType.Fee, credit: "65FEEC", debit: "65FEED" },
    { accountingTransactionType: AccountingTransactionType.Interest, credit: "83INTC", debit: "81INTD" },
    { accountingTransactionType: AccountingTransactionType.Unrealized, credit: "82UC", debit: "82UD" },
    { accountingTransactionType: AccountingTransactionType.UnrealizedFx, credit: "82UFXC", debit: "82UFXD" },
    { accountingTransactionType: AccountingTransactionType.Realized, credit: "82RC", debit: "82RD" },
    { accountingTransactionType: AccountingTransactionType.RealizedFx, credit: "82RFXC", debit: "82RFXD" },
    { accountingTransactionType: AccountingTransactionType.ManagementFee, credit: "82MGTC", debit: "82MGTD" },
    { accountingTransactionType: AccountingTransactionType.ManagementCost, credit: "82MGTCC", debit: "82MGTCD" },
    { accountingTransactionType: AccountingTransactionType.CustodyFee, credit: "82CUSC", debit: "82CUSD" },
    { accountingTransactionType: AccountingTransactionType.Rebate, credit: "82REBC", debit: "82REBD" },
    { accountingTransactionType: AccountingTransactionType.Commission, credit: "82COMC", debit: "82COMD" },
    { accountingTransactionType: AccountingTransactionType.StampDuty, credit: "82STMPC", debit: "82STMPD" },
    { accountingTransactionType: AccountingTransactionType.TaxRestitution, credit: "82RESC", debit: "82RESD" },
    { accountingTransactionType: AccountingTransactionType.ForeignTax, credit: "82FTXC", debit: "82FTXD" },
    { accountingTransactionType: AccountingTransactionType.Tax, credit: "82TAXC", debit: "82TAXD" },
    { accountingTransactionType: AccountingTransactionType.DividendPaid, credit: "20DIVPC", debit: "20DIVPD" },
    { accountingTransactionType: AccountingTransactionType.OpeningBalance, credit: "20OPENC", debit: "20OPEND" },
    { accountingTransactionType: AccountingTransactionType.Equity, credit: "20EQTC", debit: "20EQTD" },
    { accountingTransactionType: AccountingTransactionType.ShareCapital, credit: "20SCC", debit: "20SCD" },
    { accountingTransactionType: AccountingTransactionType.Rounding, credit: "37RNDC", debit: "37RNDD" }
];

export const DEFAULT_FUND_TACCOUNT_MAPPINGS: UpsertTAccountMappingInput[] = [
    // Equity
    {
        name: "Equity",
        selector: { cicTypes: [CicTypeEnum.XXX1] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "2090",
                credit: "2090"
            }
        ]
    },
    // Opening Balance
    {
        name: "Opening Balance",
        selector: { cicTypes: [CicTypeEnum.XXX2] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.OpeningBalance,
                debit: "2090",
                credit: "2090"
            }
        ]
    },
    // Rounding
    {
        name: "Rounding",
        selector: { cicTypes: [CicTypeEnum.XXX3] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "3740",
                credit: "3740"
            },
            {
                accountingTransactionType: AccountingTransactionType.Fee,
                debit: "3740",
                credit: "3740"
            },
            {
                accountingTransactionType: AccountingTransactionType.Rounding,
                debit: "3740",
                credit: "3740"
            }
        ]
    },
    // Fund Share Classes
    {
        name: "Fund Share Classes",
        selector: { modelTypes: [InstrumentModelTypeEnum.FundInternal] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "2010",
                credit: "2010"
            },
            {
                accountingTransactionType: AccountingTransactionType.ValueChange,
                debit: "2010",
                credit: "2010"
            },
            {
                accountingTransactionType: AccountingTransactionType.ShareCapital,
                debit: "2010",
                credit: "2010"
            },
            {
                accountingTransactionType: AccountingTransactionType.DividendPaid,
                debit: "2020",
                credit: "2020"
            },
            {
                accountingTransactionType: AccountingTransactionType.Fee,
                debit: "6570",
                credit: "6570"
            },
            {
                accountingTransactionType: AccountingTransactionType.Unrealized,
                debit: "2010",
                credit: "2010"
            },
            {
                accountingTransactionType: AccountingTransactionType.Realized,
                debit: "2010",
                credit: "2010"
            },
            {
                accountingTransactionType: AccountingTransactionType.ManagementFee,
                debit: "8502",
                credit: "8502"
            },
            {
                accountingTransactionType: AccountingTransactionType.CustodyFee,
                debit: "8501",
                credit: "8501"
            },
            {
                accountingTransactionType: AccountingTransactionType.Commission,
                debit: "6570",
                credit: "6570"
            }
        ]
    },
    // Spot Instruments
    {
        name: "Spot Instruments",
        selector: {
            modelTypes: [
                InstrumentModelTypeEnum.Stock,
                InstrumentModelTypeEnum.Etf,
                InstrumentModelTypeEnum.FundExternal,
                InstrumentModelTypeEnum.PrivateEquity,
                InstrumentModelTypeEnum.RealEstate
            ]
        },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "1350",
                credit: "2350"
            },
            {
                accountingTransactionType: AccountingTransactionType.ValueChange,
                debit: "1450",
                credit: "2450"
            },
            {
                accountingTransactionType: AccountingTransactionType.AccruedInterest,
                debit: "1760",
                credit: "2960"
            },
            {
                accountingTransactionType: AccountingTransactionType.Dividend,
                debit: "8210",
                credit: "8210"
            },
            {
                accountingTransactionType: AccountingTransactionType.Fee,
                debit: "6570",
                credit: "6570"
            },
            {
                accountingTransactionType: AccountingTransactionType.Unrealized,
                debit: "8290",
                credit: "8290"
            },
            {
                accountingTransactionType: AccountingTransactionType.UnrealizedFx,
                debit: "8227",
                credit: "8227"
            },
            {
                accountingTransactionType: AccountingTransactionType.Realized,
                debit: "8220",
                credit: "8220"
            },
            {
                accountingTransactionType: AccountingTransactionType.RealizedFx,
                debit: "8227",
                credit: "8227"
            },
            {
                accountingTransactionType: AccountingTransactionType.ManagementFee,
                debit: "8502",
                credit: "8502"
            },
            {
                accountingTransactionType: AccountingTransactionType.CustodyFee,
                debit: "8501",
                credit: "8501"
            },
            {
                accountingTransactionType: AccountingTransactionType.Commission,
                debit: "8503",
                credit: "8503"
            },
            {
                accountingTransactionType: AccountingTransactionType.StampDuty,
                debit: "8504",
                credit: "8504"
            },
            {
                accountingTransactionType: AccountingTransactionType.ForeignTax,
                debit: "8211",
                credit: "8211"
            },
            {
                accountingTransactionType: AccountingTransactionType.TaxRestitution,
                debit: "8212",
                credit: "8212"
            }
        ]
    },
    // Bonds
    {
        name: "Bonds",
        selector: { modelTypes: [InstrumentModelTypeEnum.Bond] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "1360",
                credit: "1360"
            },
            {
                accountingTransactionType: AccountingTransactionType.ValueChange,
                debit: "1460",
                credit: "1460"
            },
            {
                accountingTransactionType: AccountingTransactionType.AccruedInterest,
                debit: "1760",
                credit: "2960"
            },
            {
                accountingTransactionType: AccountingTransactionType.Interest,
                debit: "8251",
                credit: "8251"
            },
            {
                accountingTransactionType: AccountingTransactionType.Unrealized,
                debit: "8291",
                credit: "8291"
            },
            {
                accountingTransactionType: AccountingTransactionType.UnrealizedFx,
                debit: "8227",
                credit: "8227"
            },
            {
                accountingTransactionType: AccountingTransactionType.Realized,
                debit: "8221",
                credit: "8221"
            },
            {
                accountingTransactionType: AccountingTransactionType.RealizedFx,
                debit: "8227",
                credit: "8227"
            },
            {
                accountingTransactionType: AccountingTransactionType.ForeignTax,
                debit: "8255",
                credit: "8255"
            }
        ]
    },
    // Derivatives
    {
        name: "Derivatives",
        selector: {
            modelTypes: [
                InstrumentModelTypeEnum.Swap,
                InstrumentModelTypeEnum.Swaption,
                InstrumentModelTypeEnum.CdsBasket,
                InstrumentModelTypeEnum.CdsIndex,
                InstrumentModelTypeEnum.PortfolioSwapX
            ]
        },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "1370",
                credit: "2370"
            },
            {
                accountingTransactionType: AccountingTransactionType.ValueChange,
                debit: "1470",
                credit: "2470"
            },
            {
                accountingTransactionType: AccountingTransactionType.AccruedInterest,
                debit: "1770",
                credit: "2970"
            },
            {
                accountingTransactionType: AccountingTransactionType.Interest,
                debit: "8419",
                credit: "8252"
            },
            {
                accountingTransactionType: AccountingTransactionType.Unrealized,
                debit: "8295",
                credit: "8295"
            },
            {
                accountingTransactionType: AccountingTransactionType.UnrealizedFx,
                debit: "8228",
                credit: "8228"
            },
            {
                accountingTransactionType: AccountingTransactionType.Realized,
                debit: "8223",
                credit: "8223"
            },
            {
                accountingTransactionType: AccountingTransactionType.RealizedFx,
                debit: "8228",
                credit: "8228"
            },
            {
                accountingTransactionType: AccountingTransactionType.Dividend,
                debit: "8296",
                credit: "8296"
            }
        ]
    },
    // FX Swaps
    {
        name: "FX Swaps",
        selector: { modelTypes: [InstrumentModelTypeEnum.FxSwap] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "1370",
                credit: "2370"
            },
            {
                accountingTransactionType: AccountingTransactionType.ValueChange,
                debit: "1470",
                credit: "2470"
            },
            {
                accountingTransactionType: AccountingTransactionType.Unrealized,
                debit: "8229",
                credit: "8229"
            },
            {
                accountingTransactionType: AccountingTransactionType.UnrealizedFx,
                debit: "8229",
                credit: "8229"
            },
            {
                accountingTransactionType: AccountingTransactionType.Realized,
                debit: "8229",
                credit: "8229"
            },
            {
                accountingTransactionType: AccountingTransactionType.RealizedFx,
                debit: "8229",
                credit: "8229"
            }
        ]
    },
    // Cash Account Other Currencies
    {
        name: "Cash Account Other Currencies",
        // 71 Cash for all currencies. Will be overridden below for SEK
        selector: { cicTypes: [CicTypeEnum.XX71] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "1931",
                credit: "1931"
            },
            {
                accountingTransactionType: AccountingTransactionType.ValueChange,
                debit: "1931",
                credit: "1931"
            },
            {
                accountingTransactionType: AccountingTransactionType.ForwardCash,
                debit: "1530",
                credit: "2430"
            },
            {
                accountingTransactionType: AccountingTransactionType.Fee,
                debit: "6570",
                credit: "6570"
            },
            {
                accountingTransactionType: AccountingTransactionType.Interest,
                debit: "8421",
                credit: "8311"
            },
            {
                accountingTransactionType: AccountingTransactionType.UnrealizedFx,
                debit: "8229",
                credit: "8229"
            },
            {
                accountingTransactionType: AccountingTransactionType.RealizedFx,
                debit: "8229",
                credit: "8229"
            },
            {
                accountingTransactionType: AccountingTransactionType.ManagementFee,
                debit: "8502",
                credit: "8502"
            }
        ]
    },
    // Cash Account SEK
    {
        name: "Cash Account SEK",
        // 71 Cash for SEK
        selector: { cicTypes: [CicTypeEnum.XX71], currencies: [CurrencyEnum.SEK] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "1930",
                credit: "1930"
            },
            {
                accountingTransactionType: AccountingTransactionType.ForwardCash,
                debit: "1530",
                credit: "2430"
            },
            {
                accountingTransactionType: AccountingTransactionType.Fee,
                debit: "6570",
                credit: "6570"
            },
            {
                accountingTransactionType: AccountingTransactionType.Interest,
                debit: "8421",
                credit: "8311"
            },
            {
                accountingTransactionType: AccountingTransactionType.CustodyFee,
                debit: "8501",
                credit: "8501"
            },
            {
                accountingTransactionType: AccountingTransactionType.ManagementCost,
                debit: "8505",
                credit: "8505"
            }
        ]
    },
    // Variation Margin Account
    {
        name: "Variation Margin Account",
        // 77 Captor Specific - Variation Margin Account
        selector: { cicTypes: [CicTypeEnum.XX77] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "1392",
                credit: "2385"
            },
            {
                accountingTransactionType: AccountingTransactionType.ValueChange,
                debit: "1392",
                credit: "2385"
            },
            {
                accountingTransactionType: AccountingTransactionType.Fee,
                debit: "8504",
                credit: "8504"
            },
            {
                accountingTransactionType: AccountingTransactionType.Interest,
                debit: "8418",
                credit: "8253"
            },
            {
                accountingTransactionType: AccountingTransactionType.UnrealizedFx,
                debit: "8229",
                credit: "8229"
            },
            {
                accountingTransactionType: AccountingTransactionType.RealizedFx,
                debit: "8229",
                credit: "8229"
            }
        ]
    },
    // Initial Margin Account
    {
        name: "Initial Margin Account",
        // 76 Captor Specific - Initial Margin Account
        selector: { cicTypes: [CicTypeEnum.XX76] },
        values: [
            {
                accountingTransactionType: AccountingTransactionType.InitialCost,
                debit: "1393",
                credit: "1393"
            },
            {
                accountingTransactionType: AccountingTransactionType.ValueChange,
                debit: "1393",
                credit: "1393"
            },
            {
                accountingTransactionType: AccountingTransactionType.Fee,
                debit: "8504",
                credit: "8504"
            },
            {
                accountingTransactionType: AccountingTransactionType.Interest,
                debit: "8418",
                credit: "8253"
            },
            {
                accountingTransactionType: AccountingTransactionType.UnrealizedFx,
                debit: "8229",
                credit: "8229"
            },
            {
                accountingTransactionType: AccountingTransactionType.RealizedFx,
                debit: "8229",
                credit: "8229"
            }
        ]
    }
];

export const DEFAULT_TACCOUNTS: UpsertTAccountInput[] = [
    {
        number: "1350",
        type: TAccountTypeEnum.Asset,
        description: "Aktier och andelar",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1360",
        type: TAccountTypeEnum.Asset,
        description: "Obligationer och skuldebrev",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1370",
        type: TAccountTypeEnum.Asset,
        description: "Derivat",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1371",
        type: TAccountTypeEnum.Asset,
        description: "Derivat valuta",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1377",
        type: TAccountTypeEnum.Asset,
        description: "Värdepapper interim",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.B,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1391",
        type: TAccountTypeEnum.Asset,
        description: "Erlagd Variation Margin OTC",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1392",
        type: TAccountTypeEnum.Asset,
        description: "Erlagd Variation Margin Clearade Derivat",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1393",
        type: TAccountTypeEnum.Asset,
        description: "Erlagd Initial Margin Clearade Derivat",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1450",
        type: TAccountTypeEnum.Asset,
        description: "Värdeförändring aktier och andelar",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1460",
        type: TAccountTypeEnum.Asset,
        description: "Värdeförändring obligationer och skuldebrev",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1470",
        type: TAccountTypeEnum.Asset,
        description: "Värdeförändring derivat",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1471",
        type: TAccountTypeEnum.Asset,
        description: "Värdeförändring derivat valuta",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1530",
        type: TAccountTypeEnum.Asset,
        description: "Fondlikvidfordringar",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1760",
        type: TAccountTypeEnum.Asset,
        description: "Upplupna ränteintäkter obligationer",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.B,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1770",
        type: TAccountTypeEnum.Asset,
        description: "Upplupna ränteintäkter derivat",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.B,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1930",
        type: TAccountTypeEnum.Asset,
        description: "Bankkonto SEK",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1931",
        type: TAccountTypeEnum.Asset,
        description: "Bankkonto utl valuta",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1932",
        type: TAccountTypeEnum.Asset,
        description: "Bankkonto Säkerheter",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1995",
        type: TAccountTypeEnum.Asset,
        description: "Värdepapperslån",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "1999",
        type: TAccountTypeEnum.Asset,
        description: "Avrundning",
        group1: TAccountGroup1Enum.Assets,
        group2: TAccountGroup2Enum.C,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2010",
        type: TAccountTypeEnum.Liability,
        description: "ShareCapital",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ShareCapital,
        group3: TAccountGroup3Enum.ShareCapital,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2020",
        type: TAccountTypeEnum.Liability,
        description: "Betald Utdelning",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.DividendPaid,
        group3: TAccountGroup3Enum.DividendPaid,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2090",
        type: TAccountTypeEnum.Liability,
        description: "Balanserat resultat",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.RetainedEarnings,
        group3: TAccountGroup3Enum.RetainedEarnings,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2350",
        type: TAccountTypeEnum.Liability,
        description: "Aktier",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2360",
        type: TAccountTypeEnum.Liability,
        description: "Obligationer",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2370",
        type: TAccountTypeEnum.Liability,
        description: "Derivat",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2371",
        type: TAccountTypeEnum.Liability,
        description: "Derivat valuta",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2377",
        type: TAccountTypeEnum.Liability,
        description: "Fondhandel interim",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.B,
        group3: TAccountGroup3Enum.B,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2380",
        type: TAccountTypeEnum.Liability,
        description: "Säkerhetshantering OTC (erhållen Variation Margin)",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.B,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2385",
        type: TAccountTypeEnum.Liability,
        description: "Säkerhetshantering Clearade derivat (erhållen Variation Margin)",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.B,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2395",
        type: TAccountTypeEnum.Liability,
        description: "Värdepapperslån",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.B,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2430",
        type: TAccountTypeEnum.Liability,
        description: "Fondlikvidskulder",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.B,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2450",
        type: TAccountTypeEnum.Liability,
        description: "Värdeförändring aktier och andelar",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2460",
        type: TAccountTypeEnum.Liability,
        description: "Värdeförändring obligationer och skuldebrev",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2470",
        type: TAccountTypeEnum.Liability,
        description: "Värdeförändring derivat",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2471",
        type: TAccountTypeEnum.Liability,
        description: "Värdeförändring derivat valuta",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.A,
        group3: TAccountGroup3Enum.A,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2960",
        type: TAccountTypeEnum.Liability,
        description: "Upplupna räntekostnader obligationer",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.B,
        group3: TAccountGroup3Enum.B,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2970",
        type: TAccountTypeEnum.Liability,
        description: "Upplupna räntekostnader derivat",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.B,
        group3: TAccountGroup3Enum.B,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "2999",
        type: TAccountTypeEnum.Liability,
        description: "Avrundning",
        group1: TAccountGroup1Enum.Liabilities,
        group2: TAccountGroup2Enum.B,
        group3: TAccountGroup3Enum.C,
        group4: TAccountGroup4Enum.None,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "3740",
        type: TAccountTypeEnum.Income,
        description: "Öresutjämning",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.D,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "6570",
        type: TAccountTypeEnum.Income,
        description: "Bankkostnader",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.C,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8210",
        type: TAccountTypeEnum.Income,
        description: "Utdelning på aktier och andelar",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.G,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8211",
        type: TAccountTypeEnum.Income,
        description: "Innehållen källskatt",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.G,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8212",
        type: TAccountTypeEnum.Income,
        description: "Skatterestitution",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.G,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8220",
        type: TAccountTypeEnum.Income,
        description: "Resultat vid försäljning av aktier och andelar",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.A,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8221",
        type: TAccountTypeEnum.Income,
        description: "Resultat vid försäljning av obligationer och andra fordringar",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.A,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8223",
        type: TAccountTypeEnum.Income,
        description: "Resultat vid försäljning derivat",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.C,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8227",
        type: TAccountTypeEnum.Income,
        description: "Resultat valuta (reat och oreat) överlåtbara värdepapper",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.A,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8228",
        type: TAccountTypeEnum.Income,
        description: "Resultat valuta (reat och oreat) OTC-derivat",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.C,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8229",
        type: TAccountTypeEnum.Income,
        description: "Resultat vid försäljning valuta",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.H,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8251",
        type: TAccountTypeEnum.Income,
        description: "Ränteintäkter - obligationer",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.F,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8252",
        type: TAccountTypeEnum.Income,
        description: "Ränteintäkter - derivat",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.F,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8253",
        type: TAccountTypeEnum.Income,
        description: "Ränteintäkter - säkerhetshantering",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.F,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8255",
        type: TAccountTypeEnum.Income,
        description: "Innehållen kupongskatt ränteintäkter",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.F,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8270",
        type: TAccountTypeEnum.Income,
        description: "Erhållen provision",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.J,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8290",
        type: TAccountTypeEnum.Income,
        description: "Värdeförändring aktier och andelar",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.A,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8291",
        type: TAccountTypeEnum.Income,
        description: "Värdeförändring obl & räntebärande",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.A,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8295",
        type: TAccountTypeEnum.Income,
        description: "Värdeförändring Derivat",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.D,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8296",
        type: TAccountTypeEnum.Income,
        description: "Kreditförlust derivat",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.D,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8311",
        type: TAccountTypeEnum.Income,
        description: "Ränteintäkter bank",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.F,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8312",
        type: TAccountTypeEnum.Income,
        description: "Ränteintäkter fastighetsutlåning",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Revenue,
        group4: TAccountGroup4Enum.F,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8411",
        type: TAccountTypeEnum.Income,
        description: "Räntekostnader obligationer",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.B,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8418",
        type: TAccountTypeEnum.Income,
        description: "Räntekostnader säkerhetshantering",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.B,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8419",
        type: TAccountTypeEnum.Income,
        description: "Räntekostnader derivat",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.B,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8421",
        type: TAccountTypeEnum.Income,
        description: "Räntekostnader bank",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.B,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8501",
        type: TAccountTypeEnum.Income,
        description: "Depåavgifter",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.D,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8502",
        type: TAccountTypeEnum.Income,
        description: "Förvaltningsavgift",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.ManagementFees,
        group5: TAccountGroup5Enum.A
    },
    {
        number: "8503",
        type: TAccountTypeEnum.Income,
        description: "Courtagekostnad",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.D,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8504",
        type: TAccountTypeEnum.Income,
        description: "Clearingkostnader",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.D,
        group5: TAccountGroup5Enum.None
    },
    {
        number: "8505",
        type: TAccountTypeEnum.Income,
        description: "Andra administrativa- eller driftskostnader",
        group1: TAccountGroup1Enum.Equity,
        group2: TAccountGroup2Enum.ProfitLossCurrentYear,
        group3: TAccountGroup3Enum.Expenses,
        group4: TAccountGroup4Enum.D,
        group5: TAccountGroup5Enum.None
    }
];
